module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-392e29d3.png";